import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import ErrorCard from '../ErrorCard';

const US_FLAG_SRC = 'data:image/svg+xml;base64,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';

const Container = styled.div`
  margin: 32px 0;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
`;

const FlagPrefix = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 12px;
  border: 2px solid var(--zyvgo-border, #e1e5e9);
  border-right: none;
  border-radius: var(--zyvgo-radius-sm, 6px) 0 0 var(--zyvgo-radius-sm, 6px);
  background-color: #f8f9fa;
  font-size: 1rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  white-space: nowrap;
  user-select: none;

  ${({ $focused }) => $focused && `
    border-color: var(--zyvgo-primary, #222222);
  `}
`;

const FlagEmoji = styled.span`
  font-size: 1.25rem;
  line-height: 1;
`;

const PrefixText = styled.span`
  font-weight: 500;
  color: var(--zyvgo-text-primary, #222222);
`;

const StyledInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 16px 20px;
  border: 2px solid var(--zyvgo-border, #e1e5e9);
  border-left: none;
  border-radius: 0 var(--zyvgo-radius-sm, 6px) var(--zyvgo-radius-sm, 6px) 0;
  font-size: 1rem;
  font-family: var(--zyvgo-font-family);
  color: var(--zyvgo-text-primary, #222222);
  background-color: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--zyvgo-primary, #222222);
    box-shadow: 0 0 0 3px rgba(34, 34, 34, 0.1);
  }

  &::placeholder {
    color: #999999;
  }
`;

const ErrorMessage = styled.div`
  color: var(--zyvgo-error, #e74c3c);
  font-size: 0.875rem;
  margin-top: 12px;
  font-weight: 500;
`;

/**
 * Strip everything except digits from a string.
 */
function digitsOnly(str) {
  return (str || '').replace(/\D/g, '');
}

/**
 * Format 10 digits as (XXX) XXX-XXXX for display.
 */
function formatPhone(digits) {
  if (!digits) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/**
 * Extract raw 10-digit number from an E.164 value like "+12345678901".
 * Always strips the +1 country code prefix before extracting digits.
 */
function extractDigitsFromE164(value) {
  if (!value) return '';
  // Always strip the +1 prefix we add, then extract digits
  const stripped = value.startsWith('+1') ? value.slice(2) : value;
  return digitsOnly(stripped).slice(0, 10);
}

const PhoneNumberInput = ({ question, value, onChange, error }) => {
  const [digits, setDigits] = useState(() => extractDigitsFromE164(value));
  const [isFocused, setIsFocused] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const inputRef = useRef(null);

  // Sync from parent value (e.g. autosave restore)
  useEffect(() => {
    const parentDigits = extractDigitsFromE164(value);
    if (parentDigits !== digits) {
      setDigits(parentDigits);
    }
  }, [value]);

  const handleChange = (e) => {
    const raw = digitsOnly(e.target.value);
    const digitsBeforeCursor = digitsOnly(e.target.value.slice(0, e.target.selectionStart ?? e.target.value.length)).length;
    // Limit to 10 digits
    const capped = raw.slice(0, 10);
    setDigits(capped);

    // Clear validation error when user is typing
    if (validationError) {
      setValidationError(null);
    }

    // Send to parent in E.164 format: +1XXXXXXXXXX
    if (capped.length > 0) {
      onChange(`+1${capped}`);
    } else {
      onChange('');
    }

    requestAnimationFrame(() => {
      if (!inputRef.current) return;
      const formatted = formatPhone(capped);
      let cursor = 0;
      let seenDigits = 0;
      while (cursor < formatted.length && seenDigits < digitsBeforeCursor) {
        if (/\d/.test(formatted[cursor])) seenDigits += 1;
        cursor += 1;
      }
      inputRef.current.setSelectionRange(cursor, cursor);
    });
  };

  const handleKeyDown = (e) => {
    if (e.key !== 'Backspace' || e.currentTarget.selectionStart !== e.currentTarget.selectionEnd) return;
    const cursor = e.currentTarget.selectionStart;
    const formatted = e.currentTarget.value;
    if (cursor === 0 || /\d/.test(formatted[cursor - 1])) return;

    e.preventDefault();
    const digitIndex = digitsOnly(formatted.slice(0, cursor)).length - 1;
    if (digitIndex < 0) return;
    const nextDigits = digits.slice(0, digitIndex) + digits.slice(digitIndex + 1);
    setDigits(nextDigits);
    onChange(nextDigits ? `+1${nextDigits}` : '');
    requestAnimationFrame(() => inputRef.current?.setSelectionRange(cursor - 1, cursor - 1));
  };

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => {
    setIsFocused(false);
    // Validate on blur
    if (digits && digits.length < 10) {
      setValidationError('Please enter a valid 10-digit phone number');
    } else {
      setValidationError(null);
    }
  };

  return (
    <Container>
      <InputWrapper>
        <FlagPrefix $focused={isFocused}>
          <FlagEmoji aria-label="United States"><img src={US_FLAG_SRC} alt="US" width="22" height="14" style={{borderRadius: '2px', display: 'block'}} /></FlagEmoji>
          <PrefixText>+1</PrefixText>
        </FlagPrefix>
        <StyledInput
          ref={inputRef}
          type="tel"
          inputMode="numeric"
          value={formatPhone(digits)}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder="(321) 123-4567"
          maxLength={16}  /* formatted: (XXX) XXX-XXXX = 14 chars + safety */
          autoComplete="tel-national"
        />
      </InputWrapper>

      {validationError && (
        <ErrorCard
          message={validationError}
          variant="error"
        />
      )}

      {error && !validationError && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default PhoneNumberInput;
